module.exports = __webpack_public_path__ + "static/media/btn_google_signin.fdce20e8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/btn_google_signin.svg
// module id = 327
// module chunks = 6 7